import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from '@core/services/common.service';
import { DataService } from '@core/services/data.service';
import { PolicyState, PolicyStates } from '@shared/models/codebooks/policy-state';
import { LOB } from '@shared/models/LOB';
import { Lob } from '@shared/models/lob-enum';
import { PaymentStatus, PaymentStatusVariant } from '@shared/models/payment-status';
import { Policy } from '@shared/models/policy';
import { ActiveInsuranceGroup } from '@shared/models/active-insurance-group';
import { B2bService } from '@core/services/b2b.service';

@Component({
    selector: 'app-policy-b2b-lease-card',
    templateUrl: './policy-b2b-lease-card.component.html',
    styleUrls: ['./policy-b2b-lease-card.component.scss', '../../../../../shared/shared-styles.scss'],
    standalone: false
})
export class PolicyB2bLeaseCardComponent implements OnInit {
    @Input() policy: Policy;
    @Input() state: PolicyState;

    readonly lob: typeof Lob = Lob;
    readonly paymentStatusVariant: typeof PaymentStatusVariant = PaymentStatusVariant;
    readonly paymentStatus: typeof PaymentStatus = PaymentStatus;
    readonly policyStates: PolicyStates;
    public responsibility: string = '';
    public LOB = new LOB();

    constructor(
        private dataService: DataService,
        public commonService: CommonService,
        public b2b: B2bService
    ) {
        this.policyStates = this.dataService.policyStates;
    }

    ngOnInit(): void {
        if ([1160, 1161, 1042, 1043, 1044].includes(this.policy.packageId)) {
            this.responsibility = '_responsibility';
        }
    }

    getGroupByLobId(lobId: number): ActiveInsuranceGroup {
        return this.dataService.activeInsuranceGroups.find(group => group.lobIds.some(x => x === lobId));
    }

    openLink(url: string): void {
        window.open(url, '_blank');
    }

    gtm() {
        this.commonService.gtm();
    }
}
